import tonStyles from './../ton.json'

export default {
  name: '3',
  color: tonStyles.colors.SecondaryMidGrey
}
